import React from 'react';
import { Head } from '@inertiajs/react';
import { ServiceCard, BlueVariant } from '@/components/design/ServiceCard';

interface ServicioItem {
  id: number;
  title: string;
  description: string;
  imageSrc: string;
  variant: BlueVariant;
  link: string;
}

export default function ServiciosGrid() {
  // Lista de servicios de tu negocio
  const servicios: ServicioItem[] = [
    {
      id: 1,
      title: 'Reparación de Laptops',
      description: 'Reparación de multimarcas: HP, Dell, Lenovo, Asus, Acer y más. Soluciones a fallas de encendido, cambio de pantalla, bisagras y mantenimiento.',
      imageSrc: '/pictures/resources/clint-patterson-unsplash.jpg',
      variant: 'sky',
      link: '/servicios/laptops',
    },
    {
      id: 2,
      title: 'Reparación de MacBooks',
      description: 'Servicio técnico especializado en Apple. Reparación de placa madre, cambio de pantalla, batería y teclado.',
      imageSrc: '/pictures/resources/nikolai-chernichenko-unsplash.jpg',
      variant: 'blue',
      link: '/servicios/macbooks',
    },
    {
      id: 3,
      title: 'Reparación de Celulares',
      description: 'Diagnóstico y reparación multimarca (Samsung, Motorola, Xiaomi). Cambio de modulo/pantalla, pin de carga, batería y microsoldadura.',
      imageSrc: '/pictures/resources/vitaliju-unsplash.jpg',
      variant: 'indigo',
      link: '/servicios/celulares',
    },
    {
      id: 4,
      title: 'Reparación de iPhone',
      description: 'Soporte especializado para dispositivos iOS. Cambio de pantallas originales, reemplazo de tapa trasera de cristal, batería y fallas de carga.',
      imageSrc: '/pictures/resources/revendo-unsplash.jpg',
      variant: 'cyan',
      link: '/servicios/iphone',
    },
    {
      id: 5,
      title: 'Reparación de Impresoras',
      description: 'Mantenimiento preventivo y correctivo para Epson, HP, Canon, Brother.',
      imageSrc: '/pictures/resources/stanislav-staritsyn-unsplash.jpg',
      variant: 'sky',
      link: '/servicios/impresoras',
    },
    {
      id: 6,
      title: 'Impresoras Zebra',
      description: 'Servicio técnico de impresoras térmicas de etiquetas. Reemplazo de cabezales térmicos, calibración de sensores y rodillos.',
      imageSrc: '/pictures/resources/zebra-printer.jpg',
      variant: 'blue',
      link: '/servicios/zebra',
    },
    {
      id: 7,
      title: 'Video Vigilancia (CCTV)',
      description: 'Instalación y configuración de cámaras de seguridad (IP/Análogas), DVR/NVR, visión nocturna y monitoreo remoto desde tu celular.',
      imageSrc: '/pictures/resources/alan-j-hendry-unsplash.jpg',
      variant: 'indigo',
      link: '/servicios/cctv',
    },
    {
      id: 8,
      title: 'Cableado Estructurado y Redes',
      description: 'Diseño e instalación de redes LAN/Wi-Fi, armado de racks, parcheo, certificación de puntos de red y optimización para empresas y locales.',
      imageSrc: '/pictures/resources/nathan-dumlao-unsplash.jpg',
      variant: 'cyan',
      link: '/servicios/redes',
    },
  ];

  return (
    <section className="w-full">
      

      {/* Tu contenedor Grid personalizado */}
      <div className="bg-slate-200 py-12 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 justify-items-center px-4 md:px-8">
        {servicios.map((servicio) => (
          <ServiceCard
            key={servicio.id}
            variant={servicio.variant}
            imageSrc={servicio.imageSrc}
            title={servicio.title}
            description={servicio.description}
            buttonText="Más información"
            onButtonClick={() => {
              // Con Inertia puedes redirigir así: router.visit(servicio.link)
              window.location.href = servicio.link;
            }}
          />
        ))}
      </div>
    </section>
  );
}